<div class="footer-links">
  <a href="/new-ticket" class="footer-link" i18n="footer-links|Contact link">Contact</a>
  <a href="#" class="footer-link" i18n="footer-links|Imprint link">Imprint</a>
  <a href="#" class="footer-link" i18n="footer-links|Disclaimer link">Disclaimer</a>
  <a href="#" class="footer-link" i18n="footer-links|Privacy policy link">Privacy Policy</a>
  <a href="#" class="footer-link" i18n="footer-links|Terms and conditions link">Terms and Conditions</a>
  <a href="#" class="footer-link" i18n="footer-links|Registration agreement link">Registration Agreement</a>
  <a href="#" class="footer-link" i18n="footer-links|Registrant rights link">Registrant Rights and Responsibilities</a>
  <a href="#" class="footer-link" i18n="footer-links|Data processing agreement link">Data Processing Agreement</a>
</div>
